import type { UserType } from "../types";

export default function getProfileSchema(user: UserType, imageUrl?: string) {
  const { bio, firstName, followersCount, lastName, username } = user;

  // biome-ignore lint/suspicious/noExplicitAny: json
  const profileData: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "Person",
    url: `${process.env.APP_URL}/@${username}`,
    ...(imageUrl && { image: imageUrl }),
    alternateName: username,
    mainEntityOfPage: {
      "@id": `${process.env.APP_URL}/@${username}`,
      "@type": "ProfilePage",
    },
  };

  if (firstName || lastName) {
    profileData.name = `${firstName || ""} ${lastName || ""}`.trim();
  }

  if (bio) {
    profileData.description = bio;
  }

  if (!!followersCount && followersCount > 0) {
    profileData.interactionStatistic = [
      {
        "@type": "InteractionCounter",
        interactionType: {
          "@type": "http://schema.org/FollowAction",
        },
        userInteractionCount: followersCount,
      },
    ];
  }

  return profileData;
}
